(() => {
  const storageKey = (productId) => 'fi-akla-past-request-' + productId;

  const findButton = (form) =>
    form.querySelector('.fi-akla-detailed-card__request, .fi-product__past-request');

  const markSubmitted = (form) => {
    const button = findButton(form);
    const defaultText = form.querySelector('[data-fi-request-default]');
    const submittedText = form.querySelector('[data-fi-request-submitted]');
    const emailField = form.querySelector('[data-fi-request-email]');

    button?.classList.add('is-submitted');
    if (button) button.disabled = true;
    if (defaultText) defaultText.hidden = true;
    if (submittedText) {
      submittedText.hidden = false;
      submittedText.textContent = form.dataset.fiSentLabel || submittedText.textContent;
    }
    if (emailField) emailField.hidden = true;
  };

  const saveSubmittedState = (productId) => {
    if (!productId) return;
    try {
      localStorage.setItem(storageKey(productId), 'submitted');
    } catch (_) {}
  };

  const captureSuccessfulReturn = () => {
    const url = new URL(window.location.href);
    const productId = url.searchParams.get('meal_id');

    if (url.searchParams.get('meal_request') !== 'sent' || !productId) return;

    saveSubmittedState(productId);
    url.searchParams.delete('meal_request');
    url.searchParams.delete('meal_id');

    const query = url.searchParams.toString();
    window.history.replaceState(
      {},
      '',
      url.pathname + (query ? '?' + query : '') + url.hash
    );
  };

  const restoreSubmittedStates = () => {
    document.querySelectorAll('[data-fi-past-request]').forEach((form) => {
      try {
        if (localStorage.getItem(storageKey(form.dataset.productId)) === 'submitted') {
          markSubmitted(form);
        }
      } catch (_) {}
    });
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-fi-past-request]');
    if (!form) return;
    event.preventDefault();

    const button = findButton(form);
    const status = form.querySelector('[data-fi-request-status]');
    const defaultText = form.querySelector('[data-fi-request-default]');
    const submittedText = form.querySelector('[data-fi-request-submitted]');
    const emailInput = form.querySelector('[name="contact[email]"]');
    const message = form.querySelector('[data-fi-request-body]');

    if (!button || button.disabled) {
      event.preventDefault();
      return;
    }

    if (message && emailInput?.value) {
      message.value = message.value.replace(
        /^Customer email:.*$/m,
        'Customer email: ' + emailInput.value
      );
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    /*
     * Shopify's native contact endpoint returns to the originating page but
     * strips the custom success query parameters in some storefront contexts.
     * Persist the valid request before the native POST so the confirmation
     * survives that redirect instead of reverting to the default label.
     */
    button.disabled = true;
    button.classList.remove('is-error');
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Request failed');
      saveSubmittedState(form.dataset.productId);
      markSubmitted(form);
      if (status) status.textContent = form.dataset.fiStatusLabel || '';
    } catch (_) {
      button.disabled = false;
      button.classList.add('is-error');
      if (status) status.textContent = 'Please try again.';
    }
  });

  const init = () => {
    captureSuccessfulReturn();
    restoreSubmittedStates();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
